export function parseExpenseSearchQuery(query) {
  return String(query ?? "")
    .trim()
    .toLocaleLowerCase()
    .split(/\s*[,|]\s*/u)
    .map((group) => group.split(/\s+/).filter(Boolean))
    .filter((group) => group.length > 0);
}

export function matchesExpenseSearchQuery(searchText, queryGroups) {
  if (!Array.isArray(queryGroups) || queryGroups.length === 0) {
    return true;
  }

  const normalizedSearchText = String(searchText ?? "").toLocaleLowerCase();

  return queryGroups.some((group) => (
    group.every((term) => normalizedSearchText.includes(term))
  ));
}
